import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import N from "./Circle.js";
import z from "./Line.js";
import I from "./MultipleCircle.js";
import W from "./styles/index.cssr.js";
import O from "../../_mixins/use-config.js";
import w from "../../_mixins/use-theme.js";
import T from "../styles/light.js";
import { createKey as B } from "../../_utils/cssr/index.js";
import { useThemeClass as $ } from "../../_mixins/use-css-vars-class.js";
import { defineComponent as L, computed as m, h as p } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const k = Object.assign(Object.assign({}, w.props), {
  processing: Boolean,
  type: {
    type: String,
    default: "line"
  },
  gapDegree: Number,
  gapOffsetDegree: Number,
  status: {
    type: String,
    default: "default"
  },
  railColor: [String, Array],
  railStyle: [String, Array],
  color: [String, Array, Object],
  viewBoxWidth: {
    type: Number,
    default: 100
  },
  strokeWidth: {
    type: Number,
    default: 7
  },
  percentage: [Number, Array],
  unit: {
    type: String,
    default: "%"
  },
  showIndicator: {
    type: Boolean,
    default: !0
  },
  indicatorPosition: {
    type: String,
    default: "outside"
  },
  indicatorPlacement: {
    type: String,
    default: "outside"
  },
  indicatorTextColor: String,
  circleGap: {
    type: Number,
    default: 1
  },
  height: Number,
  borderRadius: [String, Number],
  fillBorderRadius: [String, Number],
  offsetDegree: Number
}), Q = L({
  name: "Progress",
  props: k,
  setup(e) {
    const h = m(() => e.indicatorPlacement || e.indicatorPosition), c = m(() => {
      if (e.gapDegree || e.gapDegree === 0)
        return e.gapDegree;
      if (e.type === "dashboard")
        return 75;
    }), {
      mergedClsPrefixRef: o,
      inlineThemeDisabled: n
    } = O(e), s = w("Progress", "-progress", W, T, e, o), l = m(() => {
      const {
        status: t
      } = e, {
        common: {
          cubicBezierEaseInOut: d
        },
        self: {
          fontSize: g,
          fontSizeCircle: C,
          railColor: u,
          railHeight: b,
          iconSizeCircle: y,
          iconSizeLine: x,
          textColorCircle: S,
          textColorLineInner: P,
          textColorLineOuter: i,
          lineBgProcessing: f,
          fontWeightCircle: v,
          [B("iconColor", t)]: D,
          [B("fillColor", t)]: a
        }
      } = s.value;
      return {
        "--n-bezier": d,
        "--n-fill-color": a,
        "--n-font-size": g,
        "--n-font-size-circle": C,
        "--n-font-weight-circle": v,
        "--n-icon-color": D,
        "--n-icon-size-circle": y,
        "--n-icon-size-line": x,
        "--n-line-bg-processing": f,
        "--n-rail-color": u,
        "--n-rail-height": b,
        "--n-text-color-circle": S,
        "--n-text-color-line-inner": P,
        "--n-text-color-line-outer": i
      };
    }), r = n ? $("progress", m(() => e.status[0]), l, e) : void 0;
    return {
      mergedClsPrefix: o,
      mergedIndicatorPlacement: h,
      gapDeg: c,
      cssVars: n ? void 0 : l,
      themeClass: r == null ? void 0 : r.themeClass,
      onRender: r == null ? void 0 : r.onRender
    };
  },
  render() {
    const {
      type: e,
      cssVars: h,
      indicatorTextColor: c,
      showIndicator: o,
      status: n,
      railColor: s,
      railStyle: l,
      color: r,
      percentage: t,
      viewBoxWidth: d,
      strokeWidth: g,
      mergedIndicatorPlacement: C,
      unit: u,
      borderRadius: b,
      fillBorderRadius: y,
      height: x,
      processing: S,
      circleGap: P,
      mergedClsPrefix: i,
      gapDeg: f,
      gapOffsetDegree: v,
      themeClass: D,
      $slots: a,
      onRender: R
    } = this;
    return R == null || R(), p("div", {
      class: [D, `${i}-progress`, `${i}-progress--${e}`, `${i}-progress--${n}`],
      style: h,
      "aria-valuemax": 100,
      "aria-valuemin": 0,
      "aria-valuenow": t,
      role: e === "circle" || e === "line" || e === "dashboard" ? "progressbar" : "none"
    }, e === "circle" || e === "dashboard" ? p(N, {
      clsPrefix: i,
      status: n,
      showIndicator: o,
      indicatorTextColor: c,
      railColor: s,
      fillColor: r,
      railStyle: l,
      offsetDegree: this.offsetDegree,
      percentage: t,
      viewBoxWidth: d,
      strokeWidth: g,
      gapDegree: f === void 0 ? e === "dashboard" ? 75 : 0 : f,
      gapOffsetDegree: v,
      unit: u
    }, a) : e === "line" ? p(z, {
      clsPrefix: i,
      status: n,
      showIndicator: o,
      indicatorTextColor: c,
      railColor: s,
      fillColor: r,
      railStyle: l,
      percentage: t,
      processing: S,
      indicatorPlacement: C,
      unit: u,
      fillBorderRadius: y,
      railBorderRadius: b,
      height: x
    }, a) : e === "multiple-circle" ? p(I, {
      clsPrefix: i,
      strokeWidth: g,
      railColor: s,
      fillColor: r,
      railStyle: l,
      viewBoxWidth: d,
      percentage: t,
      showIndicator: o,
      circleGap: P
    }, a) : null);
  }
});
export {
  Q as default,
  k as progressProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/progress/src/Progress.js
// module id = 1732
// module chunks = 67